/* @flow */
import * as React from 'react';
import Text from 'components/Text';
import Link from 'components/Link';
import AsyncSelectItem from 'components/AsyncSelectItem';

import type { OrganizationType } from 'queries/__generated__/globalGQLTypes';

type Props = {
  type: OrganizationType,
};

class OrganizationPickerNewItem extends React.Component<Props> {
  render() {
    return (
      <AsyncSelectItem title="we_dont_care">
        <Text>
          Can’t find your {this.props.type}? <Link weight="semibold">Add it now</Link>
        </Text>
      </AsyncSelectItem>
    );
  }
}

export default OrganizationPickerNewItem;
